import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'running-report-diagram-popup',
  templateUrl: 'running-report-diagram-popup.component.html',
})
export class RunningReportDiagramPopupComponent implements OnInit {
  initialized = false;

  @Input()
  url: string;

  @Input()
  title: string;


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
